import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import $ from 'jquery'
import { filter } from 'rxjs/operators';

declare let gtag: Function;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})


export class AppComponent implements OnInit {
  title = 'myself';

/**
 *
 */
constructor(public router:Router) {
  this.setUpAnalytics()
  
}
  ngOnInit(): void {
    
  }

  hide_menu(){
    console.log("collapsing");
    $(this).collapse('hide');
  }

  openCV(){
    console.log("opening CV");
    window.open("../assets/Bhardwaj_Sakshi_CV.pdf")
  }

  openResume(){
    window.open("../assets/Bhardwaj_Sakshi_CV.pdf")
  }

  setUpAnalytics() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          console.log(event)
            gtag('config', 'G-S691NGMQBB',
                {
                    page_path: event.urlAfterRedirects
                }
            );
        });
}
  
}
